import React, { useState } from "react";
import axios from "../../utils/axiosConfig";
import { useLookup } from "../../utils/useLookup";
import { formatReportDate } from "../../utils/reportDate";

const OverduePaymentStatusReport = () => {
  const { buyers } = useLookup();
  const [buyerId, setBuyerId] = useState("");
  const [rows, setRows] = useState([]);
  const [generated, setGenerated] = useState(false);

  const fmt = formatReportDate;

  const handleGenerate = async () => {
    try {
      const body = {};
      if (buyerId) body.buyerId = Number(buyerId);
      const res = await axios.post("/newdeal/report/overdue-payment", body);
      setRows(res.data);
      setGenerated(true);
    } catch { alert("Failed to generate report."); }
  };

  return (
    <div className="container-fluid mt-3">
      <div className="card shadow-sm border-0">
        <div className="card-header bg-white">
          <span className="badge bg-success fs-6 px-3 py-2">Overdue Payment Status Report</span>
        </div>
        <div className="card-body">
          <div className="row g-3 mb-3 align-items-end">
            <div className="col-md-3">
              <label className="form-label">Select Buyer</label>
              <select className="form-select form-select-sm" value={buyerId} onChange={e => setBuyerId(e.target.value)}>
                <option value="">All Buyer</option>
                {buyers.map(b => <option key={b.BuyerID} value={b.BuyerID}>{b.BuyerName}</option>)}
              </select>
            </div>
            <div className="col-md-2">
              <button className="btn btn-success btn-sm" onClick={handleGenerate}>Generate Report</button>
            </div>
          </div>

          {generated && (
            <>
              <div className="mb-2 text-muted" style={{ fontSize: "13px" }}>Total Records: {rows.length}</div>
              <div style={{ overflowX: "auto" }}>
                <table className="table table-bordered table-hover table-sm" style={{ fontSize: "13px" }}>
                  <thead className="table-success">
                    <tr>
                      <th>#</th><th>Deal ID</th><th>Deal Date</th><th>Buyer</th><th>Shipper</th>
                      <th>Total Qty</th><th>Containers</th><th>Payment Mode</th>
                      <th>Balance Days</th><th>Balance Amt</th>
                      <th>Invoice Date</th><th>Due Date</th><th>Payment Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {rows.length === 0
                      ? <tr><td colSpan={13} className="text-center text-muted py-3">No records found.</td></tr>
                      : rows.map((r, i) => (
                        <tr key={i}>
                          <td>{i + 1}</td><td>{r.DealID}</td><td>{fmt(r.DealDate)}</td>
                          <td>{r.BuyerName || "-"}</td><td>{r.ShipperName || "-"}</td>
                          <td>{r.TotalQty ?? "-"}</td><td>{r.NoOfContainer ?? "-"}</td>
                          <td>{r.PaymentMode || "-"}</td>
                          <td>{r.BalanceDays ?? "-"}</td><td>{r.BalanceAmount ?? "-"}</td>
                          <td>{fmt(r.InvoiceDate)}</td><td>{fmt(r.DueDate)}</td>
                          <td>
                            <span className={`badge ${r.PaymentStatus === "Overdue" ? "bg-danger" : "bg-success"}`}>
                              {r.PaymentStatus || "-"}
                            </span>
                          </td>
                        </tr>
                      ))}
                  </tbody>
                </table>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default OverduePaymentStatusReport;
